<template>
  <b-modal
    :visible="visible"
    :title="booking ? `Editar reserva ${booking.folio}` : 'Editar reserva'"
    size="lg"
    no-close-on-backdrop
    :no-close-on-esc="isSaving"
    :hide-header-close="isSaving"
    hide-footer
    @show="reset"
    @hidden="$emit('close')"
  >
    <validation-observer v-if="booking" ref="form" #default="{ invalid }">
      <b-row>
        <b-col md="12" class="mb-1">
          <b>Estatus:</b> {{ booking.statusname }}
        </b-col>
        <b-col md="3">
          <validation-provider name="Fecha de visita" rules="required" #default="{ errors }">
            <b-form-group label="Fecha de visita">
              <b-form-input v-model="form.visitDate" type="date" :state="errors[0] ? false : null" />
              <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col md="3">
          <validation-provider name="Adultos" rules="required|integer|min_value:1" #default="{ errors }">
            <b-form-group label="Adultos">
              <b-form-input v-model="form.adults" type="number" min="1" :state="errors[0] ? false : null" />
              <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col md="3">
          <validation-provider name="Menores" rules="required|integer|min_value:0" #default="{ errors }">
            <b-form-group label="Menores">
              <b-form-input v-model="form.children" type="number" min="0" :state="errors[0] ? false : null" />
              <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col md="3">
          <validation-provider name="Infantes" rules="required|integer|min_value:0" #default="{ errors }">
            <b-form-group label="Infantes">
              <b-form-input v-model="form.infants" type="number" min="0" :state="errors[0] ? false : null" />
              <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
        </b-col>
      </b-row>

      <h6 class="mt-1">Titular</h6>
      <b-row>
        <b-col md="6">
          <validation-provider name="Nombre" rules="required|max:255" #default="{ errors }">
            <b-form-group label="Nombre">
              <b-form-input v-model="form.holderName" type="text" maxlength="255" :state="errors[0] ? false : null" />
              <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col md="6">
          <validation-provider name="Apellido" rules="required|max:255" #default="{ errors }">
            <b-form-group label="Apellido">
              <b-form-input v-model="form.holderLastname" type="text" maxlength="255" :state="errors[0] ? false : null" />
              <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
        </b-col>
      </b-row>

      <div class="text-right">
        <b-button variant="secondary" class="mr-1" :disabled="isSaving" @click="$emit('close')">Cerrar</b-button>
        <b-button variant="primary" :disabled="invalid || isSaving" @click="save">
          <b-spinner small v-if="isSaving" /> Guardar
        </b-button>
      </div>
    </validation-observer>
  </b-modal>
</template>

<script>
function emptyForm() {
  return {
    visitDate: '',
    adults: 1,
    children: 0,
    infants: 0,
    holderName: '',
    holderLastname: '',
  }
}

export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    booking: {
      type: Object,
      default: null,
    },
    isSaving: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: emptyForm(),
    }
  },
  methods: {
    reset() {
      const { booking } = this
      if (!booking) {
        this.form = emptyForm()
        return
      }
      this.form = {
        visitDate: booking.visitDate || '',
        adults: booking.adults,
        children: booking.children,
        infants: booking.infants,
        holderName: booking.holderName || '',
        holderLastname: booking.holderLastname || '',
      }
    },
    async save() {
      if (this.isSaving) return
      const isValid = await this.$refs.form.validate()
      if (!isValid) return
      const { form } = this
      this.$emit('save', {
        id: this.booking.id,
        visitDate: form.visitDate,
        adults: parseInt(form.adults, 10),
        children: parseInt(form.children, 10),
        infants: parseInt(form.infants, 10),
        holderName: form.holderName.trim(),
        holderLastname: form.holderLastname.trim(),
      })
    },
  },
}
</script>
